import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconBulletedList = ({ t, className, height, width, fill }) => (
  <svg className={className} height={height} width={width}>
    <title>{t('Calendar')}</title>
    <path
      fill={fill}
      fillRule='evenodd'
      d='M16.433 17.102a.332.332 0 0 1-.331.331H1.877a.332.332 0 0 1-.331-.331V8.667h14.887v8.435zM14.343 3.55h1.759a1.88 1.88 0 0 1 1.877 1.877v11.674a1.88 1.88 0 0 1-1.877 1.877H1.877A1.88 1.88 0 0 1 0 17.102V5.428A1.88 1.88 0 0 1 1.877 3.55h2.724V1.925c0-.098-.007-.174-.016-.23a.625.625 0 0 0-.195.146A.772.772 0 1 1 3.22.83c.383-.444.949-.72 1.476-.72.172 0 .337.029.492.086.358.133.96.535.96 1.728v3.734a.774.774 0 0 1-1.547 0v-.562H1.877a.332.332 0 0 0-.331.33V7.12h14.887V5.428a.332.332 0 0 0-.331-.331h-1.76V3.55zm-2.185 12.688h2.03a.846.846 0 0 0 .846-.846v-2.03a.846.846 0 0 0-.846-.847h-2.03a.846.846 0 0 0-.846.846v2.03c0 .468.379.847.846.847zm-.326-10.58v-.562h-4.72V3.55h4.72V1.925a1.43 1.43 0 0 0-.017-.23.624.624 0 0 0-.194.146A.772.772 0 1 1 10.45.83c.383-.445.95-.72 1.477-.72.171 0 .337.029.491.086.359.133.96.535.96 1.728v3.734a.774.774 0 0 1-1.546 0z'
    />
  </svg>
)

export default Icon(IconBulletedList)
